const Routes = {
    "/dashboard": "Dashboard",
    "/dashboard/add-new-image": "Add an Image",
    "/dashboard/remove-image": "Remove an Image",
    "/dashboard/tags-manager": "Tags",
    "/dashboard/contacts-manager": "Contacts",
};

export default Routes;
